/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2020 (original work) Open Assessment Technologies SA ;
 */

export default () => {
    /**
     * Interactions implementation
     * @type {Object<string, Object>}
     */
    const interactions = {};

    /**
     * Handler of on register event
     * @type {Function}
     */
    let onRegister;

    return {
        /**
         * Register promise of the context
         */
        registerPromise: new Promise(resolve => {
            onRegister = resolve;
        }),

        /**
         * Register method that will be passed to PCI
         * @param {Object} interaction - Interaction implementation
         */
        register(interaction) {
            interactions[interaction.typeIdentifier] = interaction;
            onRegister();
        },
        /**
         * Runner function that calls getInstance function on interaction
         * @param {string} typeIdentifier - Type identifier of PCI
         * @param {HTMLElement} container - Container of PCI
         * @param {Object} configuration - Configuration of PCI
         * @param {Function} configuration.onready
         * @param {Object} state - Initial state of PCI
         */
        getInstance(typeIdentifier, container, configuration, state) {
            const interaction = interactions[typeIdentifier];
            if (interaction) {
                interaction.getInstance(container, configuration, state);
            } else {
                throw new Error(
                    `Unable to instantiate ${typeIdentifier} PCI, because it is not loaded and registered.`
                );
            }
        }
    };
};
